import { gql } from '@apollo/client';

export interface SortExercisesMutationVariables {
  courseId: string;
  subjectId: string;
  input: {
    from: number;
    to: number;
  };
}

export const sortExercisesMutation = gql`
  mutation SortExercisesMutation($courseId: String!, $subjectId: String!, $exerciseId: String!, $input: SortExercisesInput!) {
    exercises(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/reorder", method: "PUT") {
      NoResponse
    }
  }
`;
